import React, { useState, useEffect } from "react";
import { Card, Button, Space, message, Spin } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate, useHistory } from "react-router-dom";

import { useSelector } from "react-redux";
import SlaughterWasteForm from "../../components/SlaughterWasteForm";
import api from "../../api/client";

const AddSlaughterWaste = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [farms, setFarms] = useState([]);
  const [users, setUsers] = useState([]);
  const currentUser = useSelector((state) => state.account.user);

  // Fetch farms and users
  const fetchData = async () => {
    setLoading(true);
    try {
      const [farmsRes, usersRes] = await Promise.all([
        api.get(`/farm`),
        api.get(`/users`),
      ]);
      setFarms(farmsRes.data);
      setUsers(usersRes.data);
    } catch (error) {
      message.error("Failed to load data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleSuccess = () => {
    message.success("Record added successfully");
    history.push("/animal/waste-management");
  };

  return (
    <>
      <Card
        title="Add Slaughter Waste Record"
        extra={
          <Button
            icon={<ArrowLeftOutlined />}
            onClick={() => history.push("/animal/waste-management")}
          >
            Back to List
          </Button>
        }
      >
        <Spin spinning={loading}>
          <SlaughterWasteForm
            farms={farms}
            users={users}
            currentUser={currentUser}
            apiUrl={api.defaults.baseURL}
            onCancel={() => history.push("/animal/waste-management")}
            onSuccess={handleSuccess}
          />
        </Spin>
      </Card>
    </>
  );
};

export default AddSlaughterWaste;
